const presenters = {
  DrTefagh: {
    name: 'دکتر مجتبی تفاق',
    description: 'none',
    position: 'استاد دانشکده ریاضی دانشگاه صنعتی شریف',
    picture: process.env.PUBLIC_URL + '/rastalk/DrTefagh.jpg',
  },
  secondSeminar: [
    {
      name: 'سینا ریسمانچیان',
      description: 'none',
      position: 'دانشجوی مهندسی کامپیوتر',
      picture: process.env.PUBLIC_URL + '/rastalk/rismanchian.jpg',
    },
    {
      name: 'علیرضا شفیعیون',
      description: 'none',
      position: 'فارغ‌التحصیل ارشد فلسفه',
      picture: process.env.PUBLIC_URL + '/rastalk/shafiion.jpg',
    },
    {
      name: 'سید سروش رضوی',
      description: 'none',
      position: 'دانشجوی ارشد رباتیک',
      picture: process.env.PUBLIC_URL + '/rastalk/razavi.jpg',
    },
    {
      name: 'محمدمهدی مرادی',
      description: 'none',
      position: 'دانشجوی مهندسی برق',
      picture: process.env.PUBLIC_URL + '/rastalk/moradi.jpg',
    },
    {
      name: 'محمد صادقی',
      description: 'none',
      position: 'دانشجوی مهندسی برق',
      picture: process.env.PUBLIC_URL + '/rastalk/sadeghi.jpg',
    },
    {
      name: 'احسان شریفیان',
      description: 'none',
      position: 'دانشجوی مهندسی برق',
      picture: process.env.PUBLIC_URL + '/rastalk/sharifian.jpg',
    },
    {
      name: 'فائزه لباف',
      description: 'none',
      position: 'دانشجوی ارشد علوم داده',
      picture: process.env.PUBLIC_URL + '/rastalk/labbaf.jpg',
    },
    {
      name: 'عرفان فرهادی',
      description: 'none',
      position: 'دانشجوی مهندسی کامپیوتر',
      picture: process.env.PUBLIC_URL + '/rastalk/farhadi.jpg',
    },
    {
      name: 'رسول اخوان',
      description: 'none',
      position: 'دانشجوی امنیت(نترس! نه از اون امنیتا که فکر میکنی)',
      picture: process.env.PUBLIC_URL + '/rastalk/akhavan.jpg',
    },
    {
      name: 'حسین فیروز',
      description: 'none',
      position: 'دانشجوی علوم کامپیوتر',
      picture: process.env.PUBLIC_URL + '/rastalk/firooz.jpg',
    },
    {
      name: 'ارغوان رضوانی',
      description: 'none',
      position: 'دانشجوی مهندسی کامپیوتر',
      picture: process.env.PUBLIC_URL + '/rastalk/rezvani.jpg',
    },
    {
      name: 'فاطمه نیکوکار',
      description: 'none',
      position: 'دانشجوی مهندسی شیمی',
      picture: process.env.PUBLIC_URL + '/rastalk/nikookar.jpg',
    },
    {
      name: 'نیلوفر لطیفیان',
      description: 'none',
      position: 'دانشجوی کارشناسی ارشد مهندسی کامپیوتر',
      picture: process.env.PUBLIC_URL + '/rastalk/latifian.jpg',
    },
    {
      name: 'شهاب کریمی',
      description: 'none',
      position: 'دانشجوی کارشناسی ارشد مهندسی کامپیوتر',
      picture: process.env.PUBLIC_URL + '/rastalk/karimi.jpg',
    },
    {
      name: 'مهتاب بیگ وردی',
      description: 'none',
      position: 'دانشجوی کارشناسی مهندسی کامپیوتر',
      picture: process.env.PUBLIC_URL + '/rastalk/bigverdi.jpg',
    },
    {
      name: 'پوریا فاطمی',
      description: 'none',
      position: 'دانشجوی مهندسی برق و علوم کامپیوتر',
      picture: process.env.PUBLIC_URL + '/rastalk/fatemi.jpeg',
    },
  ],
};
export default presenters;
